module.exports = __webpack_public_path__ + "img/advisor-img7.ea6ade4b.jpg";